import { useEffect } from "react";
import { subscribeToUserBlocksUpdated } from "@lib/blockEvents";
import { useAuthStore } from "@stores/useAuthStore";
import { useShallow } from "zustand/react/shallow";

/**
 * Listens for local Blocks reward signals and refreshes the authenticated user's profile.
 * Mount anywhere after auth is available to keep Blocks-dependent UI in sync.
 */
export function useBlocksUpdateHandler() {
  const { isAuthenticated, refreshUserProfile } = useAuthStore(
    useShallow((s) => ({
      isAuthenticated: s.isAuthenticated,
      refreshUserProfile: s.refreshUserProfile,
    })),
  );

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    let isMounted = true;

    const handleBlocksUpdate = () => {
      if (!isMounted) {
        return;
      }
      refreshUserProfile().catch((error) => {
        console.error("Failed to refresh user profile after Blocks update:", error);
      });
    };

    const unsubscribe = subscribeToUserBlocksUpdated(window, handleBlocksUpdate);
    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [isAuthenticated, refreshUserProfile]);
}
